<!-- PCBA订单 PCB 已在华秋下单 PCB信息 -->
<template>
  <div class="information">
    <div class="information__title">
      <i class="information__linker"></i>
      PCB
    </div>
    <div class="information__container">
      <InformationList :list="list">
        <!-- 订单号 -->
        <div slot="pcb_order_sn" class="information__container__tips">
          <BaseLink>{{ data.order_info && data.order_info.pcb_order_sn }}</BaseLink>
          <p>* PCBA下单后，PCB订单收货地址将变更为PCBA加工厂</p>
        </div>
      </InformationList>
    </div>
  </div>
</template>

<script>
import InformationList from './list'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },
  components: {
    InformationList
  },
  computed: {
    list() {
      const { data } = this
      return [
        {
          width: '165px',
          children: [{ label: '采购方式', value: '已在华秋下单' }]
        },
        {
          width: '537px',
          children: [{ label: '订单号', slot: 'pcb_order_sn' }]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.information {
  display: flex;
  padding: 0 15px 12px;

  .information__title {
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
    margin-right: 5px;
    width: 40px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    font-weight: 700;
    color: $--form-color-base;
    border-radius: $--border-radius-base;
    border: 1px solid $--form-color-base;
    background-color: $--input-background-color;
    .information__linker {
      @include moduleLinkerMixin(22px, horizontal, dark);
      position: absolute;
      top: -4px;
      right: -4px;
    }
  }
  .information__container {
    width: 100%;
    ::v-deep .information-list {
      padding-top: 14px;
    }
    .information__container__tips {
      display: flex;
      justify-content: space-between;
      >p {
        font-size: 12px;
        color: #E6A23C;
      }
    }
  }
}
</style>